import store from "@/store";
import router from "@/router";
import Utils from "@/support/utils";

const SNACKBAR_DEFAULT_TIMEOUT = 5000;
const SNACKBAR_DEFAULT_ERROR_COLOR = "error";
const SNACKBAR_DEFAULT_SUCCESS_COLOR = "success";
const SNACKBAR_DEFAULT_INFO_COLOR = "info";
const SNACKBAR_DEFAULT_WARNING_COLOR = "warning";

async function errorHandling(err) {
  let text = "An error occurred, please try later.";
  let code = 500;
  if (err.response) {
    code = err.response.status;
    switch (code) {
      case 400:
        text = err.response.data || err.response.statusText;
        showErrorSnackbar({ code: code, message: text });
        break;
      case 401:
        text =
          "You are not authorized for the requested operation, please login again.";
        showErrorSnackbar({ code: code, message: text });
        Utils.logout();
        break;
      case 403:
        text = "You don't have permissions for the requested operation.";
        showErrorSnackbar({ code: code, message: text });
        await router.push({ name: "dashboard" });
        break;
      case 404:
        text = "Resource not found, please contact the administrator.";
        showErrorSnackbar({ code: code, message: text });
        break;
      case 413:
        text = "Payload too large, please contact the administrator.";
        showErrorSnackbar({ code: code, message: text });
        break;
      default:
        showErrorSnackbar({ code: code, message: text });
        break;
    }
  } else {
    text = err;
    showErrorSnackbar({ code: code, message: text });
  }
}

function snackbarSuccessPayload(code, message) {
  let payload = {
    timeout: SNACKBAR_DEFAULT_TIMEOUT,
    color: SNACKBAR_DEFAULT_SUCCESS_COLOR,
    message: message,
    code: code,
  };
  return payload;
}

function showSnackbar(code, message, timeout, color) {
  let payload = {
    timeout: timeout,
    color: color,
    message: message,
    code: code,
  };
  store.dispatch("snackbar/showSnackbar", payload);
}

function showSuccessSnackbar({
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT,
}) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_SUCCESS_COLOR);
}

function showErrorSnackbar({
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT,
}) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_ERROR_COLOR);
}

function showWarningSnackbar({
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT,
}) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_WARNING_COLOR);
}

function showInfoSnackbar({
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT,
}) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_INFO_COLOR);
}

export {
  snackbarSuccessPayload,
  showSuccessSnackbar,
  showErrorSnackbar,
  showWarningSnackbar,
  showInfoSnackbar,
  errorHandling,
};
